import { Box, Chip, MinusIcon, PlusIcon } from '@forgeglobal/design-framework'
import {
  Field,
  FieldMap,
  booleanOptions,
  convertValueToConditionState,
  opsLookup,
  prettifyName,
} from 'util/SegmentUtils'
import React from 'react'
import compact from 'lodash/compact'
import moment from 'moment'

const getValueLabel = (value: string[] | string | undefined | null, field: Field) => {
  const baseValueOptions =
    field.type === 'boolean'
      ? booleanOptions
      : (field.type === 'enum' ? field.options : []).map(fieldOption => ({
          label: prettifyName(fieldOption),
          value: fieldOption,
        }))
  const valueOptions = compact([...baseValueOptions, field.isNullable && { label: 'Blank', value: 'null' }])
  if (field.type === 'datetime' && value !== 'null') {
    return <Chip color="secondary" label={moment(value as string).format('M/D/YYYY (h A)')} />
  }
  if (Array.isArray(value)) {
    return value
      .map(val => valueOptions.find(option => option.value === val)?.label ?? val)
      .map(val => <Chip key={val} color="secondary" label={val} />)
  }
  const label = valueOptions.find(option => option.value === value)?.label ?? value
  return <Chip color="secondary" label={label} />
}

export const Criterion: React.FC<{ criterion: string; isPositive?: boolean; fields: FieldMap }> = ({
  criterion,
  isPositive,
  fields,
}) => {
  const conditionState = convertValueToConditionState(criterion, fields)
  const field = fields[conditionState.name || '']
  const name = prettifyName(field.simpleName)
  const condition = opsLookup[field.type || ''].find(cond => cond.value === conditionState.operation)?.label
  const value = getValueLabel(conditionState.value, field)
  return (
    <Box key={criterion} display="flex" alignItems="center">
      <Box mr={2} display="flex" alignItems="center">
        {isPositive ? <PlusIcon /> : <MinusIcon />}
      </Box>
      <Chip color="primary" label={name} /> {condition} {value}
    </Box>
  )
}
